import type { ReactNode } from 'react'

import { FullPageSpinnerPortal } from '@/components/common/Spinner/FullPagePortal'

import { LIFFContext, useLIFFContext } from './context'

type LIFFProviderProps = {
  liffId: string | null
  children: ReactNode
  withLogin?: boolean
}

export const LIFFProvider = ({
  liffId,
  children,
  withLogin = true,
}: LIFFProviderProps) => {
  const value = useLIFFContext({ liffId: liffId || '', withLogin })

  if (!liffId || !value.isReady) {
    return <FullPageSpinnerPortal />
  }

  return <LIFFContext.Provider value={value}>{children}</LIFFContext.Provider>
}
